import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { MoneyInput, Notice, parseMoney } from "../../lib/ui";

/*
 * Manual journal entry – port of journal_entry.php (API: POST /api/journal)
 * Any number of debit and credit lines; debit total, credit total and the amount must all match.
 */

let k = 1;
const line = () => ({ key: k++, account_id: "", amount: "" });

export default function JournalEntry() {
  const api = useApi();
  const [accounts, setAccounts] = useState([]);
  const [f, setF] = useState({ payment_date: new Date().toISOString().slice(0, 10), payment_amount: "", payment_details: "" });
  const [debits, setDebits] = useState([line()]);
  const [credits, setCredits] = useState([line()]);
  const [notice, setNotice] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/api/accounts/all").then(setAccounts).catch((e) => setNotice({ tone: "err", text: e.message })); }, [api]);

  const sum = (ls) => ls.reduce((s, l) => s + parseMoney(l.amount), 0);
  const dt = sum(debits), ct = sum(credits), amt = parseMoney(f.payment_amount);
  const balanced = dt > 0 && Math.abs(dt - ct) <= 0.01 && Math.abs(dt - amt) <= 0.01;

  const Lines = ({ title, lines, set }) => (
    <section className="panel card-pad">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: ".6rem" }}>
        <h3 style={{ margin: 0 }}>{title}</h3><button type="button" className="btn sm" onClick={() => set([...lines, line()])}><i className="fas fa-plus" /> Line</button></div>
      {lines.map((l, i) => (
        <div key={l.key} style={{ display: "grid", gridTemplateColumns: "1fr 9rem auto", gap: ".5rem", marginBottom: ".5rem" }}>
          <select aria-label={`${title} account ${i + 1}`} value={l.account_id} onChange={(e) => set(lines.map((x) => (x.key === l.key ? { ...x, account_id: e.target.value } : x)))}>
            <option value="">Choose account</option>{accounts.map((a) => <option key={a.account_number} value={a.account_number}>{a.account_number} – {a.account_name}</option>)}</select>
          <MoneyInput aria-label={`${title} amount ${i + 1}`} value={l.amount} onChange={(v) => set(lines.map((x) => (x.key === l.key ? { ...x, amount: v } : x)))} placeholder="0.00" />
          <button type="button" className="btn sm" aria-label="Remove line" disabled={lines.length === 1} onClick={() => set(lines.filter((x) => x.key !== l.key))}><i className="fas fa-xmark" /></button>
        </div>
      ))}
      <div style={{ textAlign: "right", fontSize: ".85rem" }}>Total <b className="mono">{n2(sum(lines))}</b></div>
    </section>
  );

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setNotice(null);
    try {
      const r = await api.post("/api/journal", { ...f, payment_amount: amt,
        debits: debits.map((l) => ({ account_id: l.account_id, amount: parseMoney(l.amount) })), credits: credits.map((l) => ({ account_id: l.account_id, amount: parseMoney(l.amount) })) });
      setNotice({ tone: "ok", text: `${r.message} (reference ${r.payment_id}).` });
      setF({ ...f, payment_amount: "", payment_details: "" }); setDebits([line()]); setCredits([line()]);
    } catch (err) { setNotice({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };

  return (
    <main className="pg">
      <PageHeader slug="journal_entry" />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <form onSubmit={submit}>
        <section className="panel" style={{ marginBottom: "1rem" }}>
          <div className="form" style={{ maxWidth: "none" }}>
            <div className="field"><label htmlFor="je-d">Date</label><input id="je-d" type="date" required value={f.payment_date} onChange={(e) => setF({ ...f, payment_date: e.target.value })} /></div>
            <div className="field"><label htmlFor="je-a">Amount (TZS)</label><MoneyInput id="je-a" required value={f.payment_amount} onChange={(v) => setF({ ...f, payment_amount: v })} /></div>
            <div className="field wide"><label htmlFor="je-n">Narration</label><textarea id="je-n" required rows={2} value={f.payment_details} onChange={(e) => setF({ ...f, payment_details: e.target.value })} /></div>
          </div>
        </section>
        <div className="grid2">{Lines({ title: "Debit", lines: debits, set: setDebits })}{Lines({ title: "Credit", lines: credits, set: setCredits })}</div>
        <div className="po-total" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "var(--card)", border: "1px solid var(--line)", borderRadius: "1rem", padding: "1rem 1.25rem" }}>
          <span className={`pill-tag ${balanced ? "ok" : "warn"}`}>{balanced ? "Balanced" : `Debits ${n2(dt)} · credits ${n2(ct)} · amount ${n2(amt)} must all match`}</span>
          <button type="submit" className="btn primary" disabled={!balanced || busy}><i className="fas fa-check" /> {busy ? "Posting…" : "Post entry"}</button>
        </div>
      </form>
    </main>
  );
}
